// How the page view looks on screen, apart from the document's page setup.
// These are the writer's own preferences, the same for every document and
// never written into an export: the color around the pages, and whether the
// paper takes the page setup's colors or the editor's.

export type PageViewBackground = 'shaded' | 'editor' | 'custom'
export type PageViewPaper = 'export' | 'editor'

export interface PageViewDisplay {
  /** Around the pages: the editor background darkened, as it is, or a color of the writer's choosing. */
  background: PageViewBackground
  /** The color for `background: 'custom'`. */
  backgroundColor: string
  /** The paper and its text: the page setup's colors, or the editor's. */
  paper: PageViewPaper
}

export const DEFAULT_PAGE_VIEW_DISPLAY: PageViewDisplay = {
  background: 'shaded',
  backgroundColor: '#7a7266',
  paper: 'export',
}

export function normalizePageViewDisplay(raw: any): PageViewDisplay {
  const d = DEFAULT_PAGE_VIEW_DISPLAY
  return {
    background: ['shaded', 'editor', 'custom'].includes(raw?.background) ? raw.background : d.background,
    backgroundColor: typeof raw?.backgroundColor === 'string' && /^#[0-9a-f]{6}$/i.test(raw.backgroundColor)
      ? raw.backgroundColor
      : d.backgroundColor,
    paper: raw?.paper === 'editor' ? 'editor' : d.paper,
  }
}
